import { ScrollCaptain } from 'scroll-captain';
import './featured-stage.scss';
class FeaturedStage {
    constructor (element, options) {
        // Options
        const defaults = {
            initAttr: 'data-featuredstage',
            triggerSuffix: 'root',
            circleValue: 'circle'
        };

        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$circle = document.querySelector(`[${this.settings.initAttr}="${this.settings.circleValue}"]`);

        // Settings
        this.animation = null;
    }

    initialize () {
        this.loadAnimation();
        this.setEvents();
    }

    loadAnimation () {
        this.animation = new ScrollCaptain(document.body, {
            triggerSuffix: this.settings.triggerSuffix,
            initAttr: this.settings.initAttr,
            bottom: `${(window.innerHeight * -1) + 136}px`,
            top: '-50%',
            updateOnResize: () => {
                this.animation.defaultOptions.bottom= `${(window.innerHeight * -1) + 136}px`;
                this.animation.defaultOptions.top= `${this.$circle.clientHeight * -1}px`;
            },
            animateCircle: {
                targetSuffix: this.settings.circleValue,
                onscroll: true,
                translateY: window.reducedMotionActive ? null : 1000,
                translateX: window.reducedMotionActive ? null : -500,
                opacity: { 0: 1, 100: 0 }
            }
        });
    }

    updateAnimation (updateRequired) {
        this.animation.defaultOptions.animateCircle.translateY = window.reducedMotionActive ? null : 1000;
        this.animation.defaultOptions.animateCircle.translateX = window.reducedMotionActive ? null : -500;

        if (updateRequired) {
            this.animation.update();
        }
    }

    setEvents () {
        window.addEventListener('motionPreferenceChanged', () => {
            this.updateAnimation(true);
        });
    }
}

export { FeaturedStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-featuredstage="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new FeaturedStage($root);
            $rootAPI.initialize();
        });
    }
});
